export default class DragScroll
{
    constructor({ rootNode })
    {
        this.rootNode = rootNode;
        this.isDragging = false;
        this.shouldClick = true;

        this.bindEvents();
    }

    bindEvents()
    {
        this.rootNode.addEventListener('mousedown', this.onMouseDown.bind(this));
        this.rootNode.addEventListener('mousemove', this.onMouseMove.bind(this));
        document.body.addEventListener('mouseup', this.onMouseUp.bind(this));
        
        this.rootNode.addEventListener('touchstart', this.onMouseDown.bind(this), { passive: false });
        this.rootNode.addEventListener('touchmove', this.onMouseMove.bind(this), { passive: false });
        document.body.addEventListener('touchend', this.onMouseUp.bind(this), { passive: false });

        this.rootNode.addEventListener('dragstart', (e) => e.preventDefault());


        this.rootNode.addEventListener('click', this.onClick.bind(this))
    }

    onMouseDown(e)
    {
        if (this.isDragging === true) {
            this.isDragging = false;
        }

        const isTouch = !!(e.touches && e.touches[0]);
        const eventData = isTouch ? e.touches[0] : e;
        const { clientX, clientY } = eventData;

        this.isDragging = true;
        this.startX = clientX + this.rootNode.scrollLeft;
        this.startY = clientY + this.rootNode.scrollTop;
        this.diffX = 0;
        this.diffY = 0;

        this.shouldClick = true;
    }

    onMouseMove(e)
    {
        if (this.isDragging !== true) {
            return;
        }

        e.preventDefault();

        const isTouch = !!(e.touches && e.touches[0]);
        const eventData = isTouch ? e.touches[0] : e;
        const { clientX, clientY } = eventData;

        this.diffX = (this.startX - (clientX + this.rootNode.scrollLeft));
        this.diffY = (this.startY - (clientY + this.rootNode.scrollTop));
        this.rootNode.scrollLeft += this.diffX;
        this.rootNode.scrollTop += this.diffY;

        const threshold = 10; // pixels
        if (Math.abs(this.diffX) > threshold || Math.abs(this.diffY) > threshold) {
            this.shouldClick = false;
        }
    }

    onMouseUp(e)
    {
        if (this.isDragging !== true) {
            return;
        }

        this.isDragging = false; 
        
        let start = 1;

        const animate = () => {
            const step = Math.sin(start);
            if (step <= 0) {
                this.diffX = 0;
                this.diffY = 0;

                window.cancelAnimationFrame(animate);
            } else {
                this.rootNode.scrollLeft += this.diffX * step;
                this.rootNode.scrollTop += this.diffY * step;
                start -= 0.04;
                window.requestAnimationFrame(animate);
            }
        }
        
        animate();
    }

    onClick(e)
    {
        if (this.shouldClick === false) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
}